<template>
  <div class="md-collapse">
    <md-list>
      <li>
        <md-button class="md-raised" style="margin-left: 24px; margin-right: 24px;" v-on:click="openPrintByNumber()">Print label via ordrenummer</md-button>
      </li>
      <li v-if="warehousePrinters && warehousePrinters.length > 0">
          <md-field>
              <label for="activeWarehousePrinter">{{$t('pages.dashboard.warehouseprinter')}}</label>
              <md-select name="activeWarehousePrinter" id="activePrinter" v-model="activeWarehousePrinterId">
                  <md-option v-for="warehousePrinter in warehousePrinters" :value="warehousePrinter.mys_warehouseprinterid">{{warehousePrinter.mys_name}}</md-option>
              </md-select>
          </md-field>
      </li>
      <li v-if="warehouses && warehouses.length > 0">
        <md-field>
          <label for="activeWarehouse">{{$t('pages.dashboard.warehouse')}}</label>
          <md-select name="activeWarehouse" id="activeAccount" v-model="activeWarehouseId">
            <md-option v-for="warehouse in warehouses" :value="warehouse.warehouseId">{{warehouse.warehouseName}}</md-option>
          </md-select>
        </md-field>
      </li>
      <md-list-item href="#" class="dropdown">
        <drop-down>
          <a slot="title" class="dropdown-toggle" data-toggle="dropdown" v-on:click="logout">
            {{$t('buttons.logout')}}<i class="material-icons">person</i>
            <p class="hidden-lg hidden-md">{{$t('pages.dashboard.profile')}}</p>
          </a>
        </drop-down>
      </md-list-item>
    </md-list>
  </div>
</template>
<script>
import {mapGetters} from "vuex";
import store from "@/store";
import apiService from "../../../services/APIService";
import Swal from "sweetalert2";

export default {
  name: 'warehouse-config-selector',
  props: {
    logout: {}
  },
  computed:{
    ...mapGetters(["user","warehouses","warehousePrinters","shops"]),
    activeWarehouseId: {
      set(value) {
        if (!value)
          return;
        store.dispatch("setWarehouseId", value);
      },
      get() {
        return store.getters.activeWarehouseId;
      }
      },
      activeWarehousePrinterId: {
        set(value) {
          if (!value)
            return;
          store.commit("SET_WAREHOUSEPRINTERID", value)
        },
        get() {
          return store.getters.activeWarehousePrinterId;
        }
    },
  },
  methods: {
    async openPrintByNumber() {
      if (!this.activeWarehousePrinterId) {
        Swal.fire({ title: "Ingen printer valgt", text: "Vælg en printer først.", icon: "warning" });
        return;
      }
      const shopOptions = (this.shops || []).map(s => {
        const dom = s.shopDomain || s.ShopDomain || "";
        const label = s.accountName || dom || s.mys_account;
        return `<option value="${s.mys_account}|${dom}">${label}</option>`;
      }).join("");

      const form = await Swal.fire({
        title: "Print label via ordrenummer",
        html:
          `<select id="pbn-shop" class="swal2-input">${shopOptions}</select>` +
          `<input id="pbn-order" class="swal2-input" placeholder="Ordrenummer">` +
          `<select id="pbn-weight" class="swal2-input"><option value="5">5 kg</option><option value="10">10 kg</option><option value="20">20 kg</option></select>`,
        focusConfirm: false,
        showCancelButton: true,
        cancelButtonText: "Annuller",
        confirmButtonText: "Find ordre",
        preConfirm: () => {
          const shop = document.getElementById("pbn-shop").value;
          const order = document.getElementById("pbn-order").value.trim();
          const weight = document.getElementById("pbn-weight").value;
          if (!order) { Swal.showValidationMessage("Indtast et ordrenummer"); return false; }
          if (!shop || shop.endsWith("|")) { Swal.showValidationMessage("Vælg en shop med et shopdomain"); return false; }
          return { shop, order, weight };
        }
      });
      if (!form.value) return;

      const parts = form.value.shop.split("|");
      const accountId = parts[0];
      const shopDomain = parts[1];
      const weight = form.value.weight;
      const orderNumber = form.value.order;

      let order = null;
      try {
        const resp = await apiService.getApi(`/portals/v1/accounts/${accountId}/orders/lookup/${shopDomain}/${orderNumber}`);
        order = resp.data;
      } catch (e) {
        order = null;
      }

      if (!order || !order.salesorderid) {
        Swal.fire({ title: "Ordre ikke fundet", html: `Ingen ordre <b>${orderNumber}</b> fundet for <b>${shopDomain}</b>.`, icon: "error" });
        return;
      }

      const confirmResult = await Swal.fire({
        title: `Ordre ${order.mys_extordernumber}`,
        html:
          `${order.billto_name || ""}<br/>` +
          `${order.shipto_name || ""}<br/>` +
          `${order.shipto_line1 || ""}<br/>` +
          `${order.shipto_postalcode || ""} ${order.shipto_city || ""}<br/><br/>` +
          `Print <b>${weight} kg</b> label?`,
        icon: "question",
        showCancelButton: true,
        cancelButtonText: "Annuller",
        confirmButtonText: `Print ${weight} kg label`
      });
      if (!confirmResult.value) return;

      try {
        await apiService.postApi(`/portals/v1/accounts/${accountId}/shipments/${order.salesorderid}/warehouseprinters/${this.activeWarehousePrinterId}/extralabel/${weight}`, null);
        Swal.fire({ title: `${weight} kg label sendt til printeren`, icon: "success", timer: 2000, showConfirmButton: false });
      } catch (e) {
        Swal.fire({ title: "Label kunne ikke printes", text: (e.response && e.response.data) ? (e.response.data.message || e.response.data.Message || "") : "", icon: "error" });
      }
    },
  },
}
</script>